import type { AlertScale } from '../domain/AlertScale';
import type { NumbersRange } from '../domain/NumbersRange';

export class AttentionStatus {
  static fromAlertScale(
    alertScale: AlertScale | undefined,
    evaluatedValue: number | undefined | null
  ): AttentionStatusType {
    return evaluatedValue == null || alertScale == null
      ? 'NO_ATTENTION_REQUIRED'
      : alertScale.match<AttentionStatusType>(evaluatedValue, {
          Ok: () => 'NO_ATTENTION_REQUIRED',
          Warning: () => 'ATTENTION_SUGGESTED',
          Error: () => 'ATTENTION_REQUIRED'
        });
  }

  static fromRange(
    numbersRange: NumbersRange | undefined,
    evaluatedValue: number | undefined
  ): AttentionStatusType {
    return evaluatedValue == null ||
      numbersRange == null ||
      numbersRange.withinRange(evaluatedValue)
      ? 'NO_ATTENTION_REQUIRED'
      : 'ATTENTION_REQUIRED';
  }
}
export type GridElementAttentionStatus = {
  status: AttentionStatusType;
};

export type AttentionStatusType =
  | 'ATTENTION_REQUIRED'
  | 'ATTENTION_SUGGESTED'
  | 'NO_ATTENTION_REQUIRED'
  | 'NOT_EVALUATED';

export type WithGridElementAttentionStatus<TType> = TType &
  GridElementAttentionStatus;
